<template>
  <div class="content if-profile">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0"
      >
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">Industry Branch Concentration</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>Is this industry becoming more subject to outside ownership decisions in your area? Are local entrepreneurs being squeezed out by
                franchises or branch operations?<br><br>
                This table shows the percentage of industry branch operations in the US and your market area as a barometer of relative
                consolidation trends. Increasing branch level may indicate pressure on area entrepreneurship.
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>
        </div>-->
        <div class="md-transparent finanical-report-messages p-0">
          <nav-tabs-card class="p-0 m-0">
            <template slot="content">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 blue-tbl p-0">
                  <md-card class="if_card">
                    <md-card-header>Ownership</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <div class="md-layout-item md-size-100">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >Industry Branch Concentration (%)</div>
                              </h4>
                              <!-- <h4 class="title text-left">Industry Branch Concentration (%)</h4> -->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                >
                                  <md-table
                                    v-model="tableDataBranchConcentration"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                                      <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                      <md-table-cell
                                        v-for="key in Object.keys(item.dates)"
                                        :key="key"
                                        :md-label="years[key]"
                                      >{{ item.dates[key] }}</md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-50">
                          <md-card class="md-card-profile graph-line-clr">
                            <md-card-content>
                              <chart-card
                                header-animation="false"
                                :chart-data="colouredLineChart.data"
                                :chart-options="colouredLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                no-footer
                                background-color="blue"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Industry Branch Concentration (%)</div>
                                  </h4>
                                  <!-- <h4 class="title">Industry Branch Concentration (%)</h4> -->
                                </template>
                              </chart-card>
                              <div class="pie-line" v-if="colouredLineChart && colouredLineChart.data && colouredLineChart.data.series">
                                <ul>
                                  <li v-for="(label, index) in colouredLineChart.data.series" :key="index + '_label'"><span class=""><i :class="'fa fa-square ' + 'chart-label-color-' + index"></i></span> {{ label.name }}</li>
                                </ul>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                         <div class="md-layout-item md-medium-size-100 md-size-50">
                         <md-card class="md-card-profile">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                              >Competitive Market Narrative</div>
                            </h4>
                          </md-card-header>
                          <md-card-content>
                            <div class="extra_space">
                              <!-- <h4 class="Performance Scores">
                                Competitive Market Narrative
                              </h4>-->
                              <p>
                                {{cmnText.ownership}}
                              </p>
                            </div>
                          </md-card-content>
                        </md-card>
                        <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >
                                  <md-icon class="color-white">article</md-icon> Ownership
                                </div>
                              </h4>
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-medium-size-100 md-size-100">
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                    </h4>-->
                                    <p>
                                      Is this industry becoming more subject to outside ownership decisions in your area?
                                      Are local entrepreneurs being squeezed out by franchises or branch operations?<br><br>
                                      This table shows the percentage of industry branch operations in the US and your market
                                      area as a barometer of relative consolidation trends. Increasing branch level may indicate
                                      pressure on area entrepreneurship.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                      </div>

                      </div>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MRReportHeader,
  },
  props: ['headerData'],
  data() {
    return {
      view: 'tableDataMarketAnnualSalesy',
      showDialog: false,
      tableDataBranchConcentration: [],
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: '300px',
        },
      },
    };
  },
  computed: {
    ...mapState({
      ownership: (state) => state.user.market_report.data.data['ownership'],
      years: (state) => state.user.market_report.data.firstYears,
      cmnText: (state) =>state.user.market_report.cmnText,
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'tableDataMarketAnnualSales';
    }

    this.switchView(section);
    this.tableDataBranchConcentration = Object.entries(
      this.ownership
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

    this.colouredLineChart.data = {
      labels: this.years,
      series: this.tableDataBranchConcentration.map((item) => ({
        name: item.name,
        data: item.dates.map((i) => Number(i)),
      })),
    };
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'tableDataMarketAnnualSales';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }
    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }

  .sub_table .md-table table tr th.md-table-head {
    background: #7041e5;
  }
}
.if-profile .if_card .md-card-profile .md-card-header {
  background: #7041e5;
}
</style>
